// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__fTuX5","load7":"Spinner_load7__3lEXz"};